"use strict";
import InvoiceInputFields from "./invoice_input_fields";
import Account from "../../api/account";
export default {
  invoiceInputFields: function() {
    if (!this._invoiceInputFieldsOwnerMixin_isIndexAuditSplitEnabled()) {
      return null;
    }
    const selectedLoad = this.props.loads.selectedLoad;
    let guessedInvoiceAmount = null;
    let guessedInvoiceNumber = null;
    if (selectedLoad) {
      const loadId = selectedLoad.load.load_id;
      const guessedInvoiceData = this.props.documentBatch.guessed_invoice_data_by_load_id[loadId];
      if (!!guessedInvoiceData) {
        guessedInvoiceAmount = guessedInvoiceData.guessed_invoice_amount;
        guessedInvoiceNumber = guessedInvoiceData.guessed_invoice_number;
      }
    }
    const guessedInvoiceDataFromSubmission = this.props.documentBatch.guessed_invoice_data_from_submission;
    guessedInvoiceAmount != null ? guessedInvoiceAmount : guessedInvoiceAmount = guessedInvoiceDataFromSubmission == null ? void 0 : guessedInvoiceDataFromSubmission.guessed_invoice_amount;
    guessedInvoiceNumber != null ? guessedInvoiceNumber : guessedInvoiceNumber = guessedInvoiceDataFromSubmission == null ? void 0 : guessedInvoiceDataFromSubmission.guessed_invoice_number;
    return /* @__PURE__ */ React.createElement(
      InvoiceInputFields,
      {
        getSelectedInvoiceForGroup: this.props.getSelectedInvoiceForGroup,
        onFieldChange: this.onInvoiceFieldChange,
        sourceInvoiceAmount: guessedInvoiceAmount,
        sourceInvoiceNumber: guessedInvoiceNumber,
        ref: "invoiceInputFields"
      }
    );
  },
  onInvoiceFieldChange: function(field, value) {
    this.setState({ [field]: value });
  },
  invoiceDataEntered() {
    return !!(this.state.source_invoice_amount && this.state.source_invoice_number);
  },
  _invoiceInputFieldsOwnerMixin_isIndexAuditSplitEnabled: function() {
    return Account.currentSettings().index_audit_split_enabled;
  },
  focusNextField: function() {
    if (this.refs.invoiceInputFields) {
      this.refs.invoiceInputFields.focusNextField();
    }
    ;
  }
};
